var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-digital-flop',{staticStyle:{"width":"100%","height":"100%"},attrs:{"config":_vm.flopConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }